// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"38d95697","498":"08e1e2c8","598":"5dd89dc3","703":"f2c60403"}[chunkId] + ".chunk.js";
};